module.exports = __webpack_public_path__ + "img/aboutc.d50cc6f1.png";